import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-amber-400 text-slate-950 shadow-lg shadow-amber-400/20 transition-[background-color,transform] hover:bg-amber-300 active:scale-[0.98]',
    secondary: 'bg-slate-900 text-white border border-slate-700 transition-[background-color,transform] hover:bg-slate-800 active:scale-[0.98]',
    outline: 'border-2 border-orange-400 bg-transparent text-orange-400 transition-colors hover:bg-slate-900'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-5 py-5 text-sm sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 text-center rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-400/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-197" data-mp="on113wha7241">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-198" data-mp="12lscvc8o8bp0" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-199" data-mp="xnz4qdnt57m3">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-200" data-mp="1cfhh81hgkk0p" />}
    </button>;
}